import styled, { css } from 'styled-components';

export const BreadcrumbTextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    
    ${props => css`
        color: ${props.color}
    `}




`;